import { useContext } from 'react';

import ClientInformationContext from '../ClientInformationContext';

const useClientInformationContext = () => {
  return useContext(ClientInformationContext);
};

export default useClientInformationContext;
